module.exports = __webpack_public_path__ + "img/marketing.a2b0f63b.svg";